import { observer } from 'mobx-react-lite';
import React, { useMemo } from 'react'
import { Link } from 'react-router-dom';
import { useStore } from 'store';
import { replacementFields } from 'utils/constants';

const StatusBar = () => {
	const store = useStore();

	const replacedFields = useMemo(() => {
		const fieldsToReplace = [...store.auth.profile.stringsToFill];

		if (store.auth.profile.backgroundCheck === false) {
			fieldsToReplace.push("Background Check");
		}

		return fieldsToReplace
			.map(word => replacementFields[word] || word)
			.join(', ');
	}, [store.auth.profile.stringsToFill, store.auth.profile.backgroundCheck, replacementFields]);

	return (
		<div className="status-bar">
			{!store.auth.user.access && (
				<div className="message">
					{store.auth.user.isProvider ? (
						<Link to={'/profile'}>
							Please complete the following information in your profile in order to begin receiving jobs: {replacedFields}
						</Link>
					) : (
						<Link to={'/profile'}>
							Please complete the following information in your profile to begin scheduling jobs: {replacedFields}
						</Link>
					)}
				</div>
			)}
		</div>
	)
}

export default observer(StatusBar)